import React from 'react'
import { Layout } from 'antd'
import Header from 'Components/Header'
import { StyledContent } from './styled'

const MainLayout = props => (
  <Layout>
    <Header />
    <StyledContent>{props.children}</StyledContent>
  </Layout>
)
export default MainLayout



// WEBPACK FOOTER //
// ./src/hoc/MainLayout/index.js